var _style, _g, _path, _path2, _path3, _g2, _g3, _path4, _defs, _defs2, _g4, _g5, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeRecommendedDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 500",
    style: {
      enableBackground: "new 0 0 520 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.facade-recommended-st0{fill:#FFFFFF;}\n\t.facade-recommended-st1{fill:none;stroke:#FFFFFF;}\n\t.facade-recommended-st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.facade-recommended-st3{fill:none;stroke:#FFFFFF;stroke-opacity:0.2;}\n\t.facade-recommended-st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;fill-opacity:0.2;}\n\t.facade-recommended-st5{fill:#FFFFFF;fill-opacity:0.2;}\n\t.facade-recommended-st6{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.facade-recommended-st7{filter:url(#Adobe_OpacityMaskFilter);}\n\t.facade-recommended-st8{clip-path:url(#SVGID_2_);fill:none;stroke:#79CCF3;stroke-miterlimit:10;}\n\t.facade-recommended-st9{mask:url(#mask1_681_6026_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st0",
    d: "M293.3,344.9c1.6-24.2,3.7-54.4-11.9-83.8l0.9-0.5c15.7,29.6,13.6,60,12,84.3c-1.2,17.9-2.2,32.8,3.4,43 c24.4-2.9,33.8-7.6,33.8-7.6l-41.8-148.2H222l-41.9,148.2c0,0,4.5,2.2,15.3,4.6c-10.2-21.7,1.5-37.7,15.4-56.7 c13-17.7,27.6-37.7,27.6-67.4h1c0,30-14.8,50.2-27.8,68c-13.8,18.9-25.4,34.7-14.9,56.4c4,0.8,8.8,1.7,14.5,2.4 c-11.5-20.7-1.2-37.5,11.1-57.5c11.4-18.6,24.3-39.7,22.3-69.2l1-0.1c2,29.8-11,51.1-22.5,69.8c-12.2,19.9-22.4,36.5-10.6,57.1 c4.2,0.5,8.8,1,14,1.4c-11.7-19.1-3.1-36.3,7.3-56.9c9.9-19.6,21-41.8,17-71.3l1-0.1c4.1,29.7-7.1,52.1-17.1,71.9 c-10.3,20.5-18.9,37.6-6.9,56.6c4.2,0.3,8.7,0.5,13.5,0.7c-11.4-17.1-4.3-34.6,4-55.5c8.3-20.7,17.7-44.1,11.5-73.5l1-0.2 c6.2,29.7-3.2,53.3-11.6,74.1c-8.3,20.8-15.3,38.1-3.7,55.1c4.2,0.1,8.5,0.2,13.2,0.2c-10.4-15.2-5-32.6,1.4-53.3 c6.7-21.8,14.3-46.5,5.9-75.9l1-0.3c8.5,29.7,0.8,54.5-5.9,76.5c-6.4,20.6-11.7,37.9-1,53c4.5,0,8.7-0.1,12.7-0.2 c-9-13.3-5.2-30.4-0.8-50.4c5.1-23,10.9-49,0.2-78.5l0.9-0.3c10.8,29.7,5,55.9-0.2,79c-4.5,20.1-8.2,37,1.1,50.2 c4.4-0.2,8.5-0.4,12.4-0.6c-7.4-11.8-5.1-28.1-2.4-47.1c3.4-24.2,7.3-51.7-5.7-81.1l0.9-0.4c13.2,29.7,9.1,58.5,5.8,81.6 c-2.7,19-5,35.3,2.6,46.9c4.4-0.3,8.4-0.7,12.1-1.1C291.1,377.4,292.1,362.3,293.3,344.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st0",
    d: "M288.3,223.4l4.8-63.2l-12.3-10.8c-0.5,10.8-6.8,31.3-25,31.3s-24.4-20.5-25-31.3l-12.4,10.9l4.8,63.2H288.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st1",
    d: "M239.8,93.1l12.6,12.6l18.8-18.8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st2",
    d: "M97.5,247l5.1,51.2h7.7c0-6.5-5.2-33.4,7.7-29.3L97.5,247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st3",
    d: "M97.5,247l5.1,51.2h7.7c0-6.5-5.2-33.4,7.7-29.3L97.5,247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st4",
    d: "M92.3,221.3h15.9l11,16.8l31.8,38.4l24.5-6l26.9,27.6h-58.8l-46.5-50.4L92.3,221.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st1",
    d: "M92.3,221.3h15.9l11,16.8l31.8,38.4l24.5-6l26.9,27.6h-58.8l-46.5-50.4L92.3,221.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st1",
    d: "M110.3,93l12.3,12.3l18.5-18.5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st5",
    d: "M350.4,215h49.7l-4.9,23.1h-39.8L350.4,215z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st1",
    d: "M350.4,215h49.7l-4.9,23.1h-39.8L350.4,215z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st6",
    d: "M424.1,226.6h-26.4l-2.5,11.5h-39.8l-2.5-11.5h-26.4l-16.9,78.8h131.2L424.1,226.6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 309.7,
    y: 226.6,
    width: 131.2,
    height: 78.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 309.7,
    y: 226.6,
    width: 131.2,
    height: 78.8,
    id: "mask1_681_6026_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "facade-recommended-st7"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 286.1,
    y: 219.7,
    width: 177,
    height: 99.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,314.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,318.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,290.6l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,295l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,267.1l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,271.5l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M384.6,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M360.1,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,243.5l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,247.9l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,220l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M458.3,224.4l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,220l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M433.8,224.4l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,220l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M409.2,224.4l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,220l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M335.5,224.4l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,220l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M311,224.4l4.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,220l4.5,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st8",
    d: "M286.4,224.4l4.5-4.4"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "facade-recommended-st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st0",
    d: "M424.1,226.6h-26.4l-2.5,11.5h-39.8l-2.5-11.5h-26.4l-16.9,78.8h131.2L424.1,226.6z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "facade-recommended-st1",
    d: "M361.4,93l12.3,12.3l18.5-18.5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeRecommendedDesktop);
export default __webpack_public_path__ + "static/media/facade-recommended-desktop.4d90f2ea.svg";
export { ForwardRef as ReactComponent };